import type { TranslationSchema } from '@/locales/schema'

export const pt: TranslationSchema = {
  common: {
    appName: 'Longbourn',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    cancel: 'Cancelar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    add: 'Adicionar',
    search: 'Buscar',
    showingResults: 'Mostrando {{start}}-{{end}} de {{total}} resultados',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
    filter: 'Filtrar',
    sort: 'Ordenar',
    yes: 'Sim',
    no: 'Não',
    optional: 'Opcional',
    confirm: 'Confirmar',
    by: 'por',
    setDate: 'definir data',
    clearAll: 'Limpar tudo',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    ascending: 'Crescente',
    descending: 'Decrescente',
    dateAdded: 'Data de Adição',
    exactlyStars: '{{stars}} estrelas',
    rangeStars: '{{min}} - {{max}} estrelas',
    noResultsMessage: 'Nenhum resultado encontrado',
    selectAll: 'Selecionar Tudo',
    deselectAll: 'Desmarcar Tudo',
    apply: 'Aplicar',
    saving: 'Salvando...',
  },
  errors: {
    general: 'Ocorreu um erro',
    userNotAuthenticated: 'Usuário não autenticado',
    somethingWentWrong:
      'Algo deu errado. Nossa equipe foi notificada e estamos trabalhando para resolver o problema.',
    errorOccurred: 'Ocorreu um erro ao processar sua solicitação',
    invalidISBN: 'Formato de ISBN inválido',
    isbnNotFound: 'Nenhum dado encontrado para este ISBN',
    networkError: 'Erro de conexão. Verifique sua internet e tente novamente.',
    tryAgain: 'Tentar novamente',
    goBack: 'Voltar ao início',
    technicalDetails: 'Detalhes técnicos',
    devOnly: 'dev only',
  },
  auth: {
    signIn: 'Entrar',
    signOut: 'Sair',
    signUp: 'Criar Conta',
    signInWithGoogle: 'Entrar com Google',
    signInWithEmail: 'Entrar com Email',
    createAccount: 'Criar Conta',
    resetPassword: 'Redefinir Senha',
    forgotPassword: 'Esqueceu sua senha?',
    backToSignIn: 'Voltar ao Login',
    signingIn: 'Entrando...',
    signingOut: 'Saindo...',
    welcomeBack: 'Bem-vindo de volta',
    yourPersonalLibrary: 'Sua biblioteca pessoal',
    bySigningIn: 'Ao entrar, você concorda em organizar sua jornada de leitura',
    madeWithLove: 'Feito com ❤️ para amantes de livros',
    signInError: 'Falha ao entrar com Google. Por favor, tente novamente.',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    fullName: 'Nome Completo',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar Senha',
    fullNamePlaceholder: 'Digite seu nome completo',
    emailPlaceholder: 'Digite seu email',
    passwordPlaceholder: 'Digite sua senha',
    confirmPasswordPlaceholder: 'Confirme sua senha',
    noAccount: 'Não tem uma conta?',
    haveAccount: 'Já tem uma conta?',
    emailRequired: 'Email é obrigatório',
    emailInvalid: 'Por favor, digite um email válido',
    passwordRequired: 'Senha é obrigatória',
    passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
    nameRequired: 'Nome completo é obrigatório',
    passwordsDoNotMatch: 'As senhas não coincidem',
    invalidCredentials: 'Email ou senha inválidos',
    emailNotConfirmed: 'Por favor, verifique seu email e confirme sua conta',
    userAlreadyExists: 'Uma conta com este email já existe',
    generalError: 'Ocorreu um erro durante a autenticação',
    setNewPassword: 'Definir Nova Senha',
    enterNewPassword: 'Digite sua nova senha abaixo',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    updatePassword: 'Atualizar Senha',
    passwordUpdated: 'Senha Atualizada!',
    passwordUpdateSuccess: 'Sua senha foi atualizada com sucesso.',
    redirectingToLogin: 'Redirecionando para página de login...',
    checkYourEmail: 'Confira seu Email',
    resetEmailSent: 'Enviamos um link de recuperação para {{email}}',
    resetEmailInstructions: 'Clique no link do email para redefinir sua senha.',
  },
  navigation: {
    dashboard: 'Painel',
    myBooks: 'Meus Livros',
    digitalShelf: 'Estante Digital',
    wishlist: 'Lista de Desejos',
    bookRoulette: 'Roleta de Livros',
    billing: 'Cobrança',
    settings: 'Configurações',
    notes: 'Anotações',
    yearInReview: 'Retrospectiva',
    clubs: 'Clubes',
  },
  billing: {
    title: 'Cobrança',
    subtitle: 'Gerencie sua assinatura e método de pagamento',
    loading: 'Carregando informações de cobrança...',
    status: {
      title: 'Status da Assinatura',
      currentStatus: 'Status Atual:',
      exemptAccess: 'Você possui acesso isento ao sistema',
      exemptAs: 'como {{reason}}',
      expiresOn: 'Expira em: {{date}}',
      trialExpiresOn: 'Trial expira em:',
    },
    subscription: {
      title: 'Detalhes da Assinatura',
      plan: 'Plano:',
      nextBilling: 'Próxima cobrança:',
      status: 'Status:',
      active: 'Ativo',
      monthly: 'Mensal',
      annual: 'Anual',
      cancelScheduled: 'Cancelamento agendado',
      cancelDate: 'Sua assinatura será cancelada em {{date}}',
    },
    manage: {
      title: 'Gerenciar Assinatura',
      description: 'Atualize método de pagamento, baixe faturas ou cancele sua assinatura',
      button: 'Gerenciar Assinatura',
      redirecting: 'Redirecionando...',
    },
    upgrade: {
      title: 'Escolha seu Plano',
      description: 'Desbloqueie todas as funcionalidades do Longbourn',
      monthly: {
        title: 'Mensal',
        price: '{{price}}',
        period: '/mês',
        cta: 'Escolher Mensal',
      },
      annual: {
        title: 'Anual',
        price: '{{price}}',
        period: '/ano',
        savings: 'Economize {{amount}} ({{percent}}% de desconto)',
        perMonth: '{{price}}/mês',
        cta: 'Escolher Anual',
        badge: 'Mais Popular',
      },
      processing: 'Processando...',
      benefits:
        '✅ Todas as funcionalidades • 📊 Análises avançadas • 🎯 Suporte prioritário • 🚫 Sem limites',
      cancelAnytime: 'Cancele a qualquer momento',
    },
    badge: {
      loading: 'Carregando...',
      exempt: 'Isento - {{reason}}',
      exemptSpecial: 'Isento - Especial',
      annual: 'Plano Anual',
      monthly: 'Plano Mensal',
      trial: 'Trial - {{days}} dia{{s}} restante{{s}}',
      trialExpired: 'Trial Expirado',
      noAccess: 'Sem Acesso',
      // New cancellation statuses
      pastDue: 'Pagamento em atraso',
      canceled: 'Assinatura cancelada',
      canceledWithAccess: '{{days}} dias restantes',
      cancelingAtPeriodEnd: 'Cancelando no fim do período',
      trialing: 'Período de teste',
      inactive: 'Inativo',
      reasons: {
        beta_tester: 'Beta Tester',
        partner: 'Parceiro',
        lifetime: 'Vitalício',
        promotional: 'Promocional',
        staff: 'Funcionário',
        investor: 'Investidor',
      },
    },
  },
  dashboard: {
    welcomeBack: 'Bem-vindo de volta, {{name}}!',
    readingJourneyOverview: 'Aqui está uma visão geral da sua jornada de leitura',
    stats: {
      totalBooks: 'Total de Livros',
      booksRead: 'Livros Lidos',
      readThisYear: 'Lidos Este Ano',
      currentlyReading: 'Lendo Atualmente',
      wishlist: 'Lista de Desejos',
      startAddingBooks: 'Comece a adicionar livros à sua biblioteca',
      percentOfCollection: '{{percent}}% da sua coleção',
      booksInProgress: 'Livros em progresso',
      booksToReadLater: 'Livros para ler depois',
      ofTotal: 'do total',
      favoriteGenre: 'Seu gênero favorito é',
      noFavoriteGenre: 'Adicione gêneros aos seus livros para descobrir seu favorito',
      booksWithGenre: 'livros',
      ownedPlusBorrowed_one: 'Só os seus · +{{count}} emprestado fora do total',
      ownedPlusBorrowed_other: 'Só os seus · +{{count}} emprestados fora do total',
      readIncludesBorrowed_one: 'Inclui {{count}} livro emprestado',
      readIncludesBorrowed_other: 'Inclui {{count}} livros emprestados',
    },
    analytics: {
      title: 'Analytics',
    },
    charts: {
      yearlyProgress: 'Progresso Anual',
      typeDistribution: 'Distribuição por Tipo',
      libraryStatus: 'Status da Biblioteca',
      libraryStatusDescription: 'Visão geral dos livros por status e tipo',
      topGenres: 'Top Gêneros',
      topGenresDescription: 'Gêneros mais presentes na sua biblioteca',
      ratingDistribution: 'Distribuição de Avaliações',
      averageRating: 'Média',
      ratedBooks: 'livros avaliados',
      noRatedBooks: 'Nenhum livro avaliado ainda',
      comingSoon: 'Em breve...',
      booksReadIn: 'livros lidos em',
      booksThisMonth: 'livros este mês',
      totalSoFar: 'total até agora',
      books: 'livros',
      booksTotal: 'livros no total',
      totalBooks: 'Total',
      booksRead: 'Lidos',
      percentageOfLibrary: 'Da biblioteca',
      percentage: 'Porcentagem',
      star: 'estrela',
      stars: 'estrelas',
      ofTotal: 'do total',
      noData: 'Dados insuficientes para exibir o gráfico',
      noDataTitle: 'Nenhum dado disponível',
      addBooksToSeeDistribution: 'Adicione livros à sua biblioteca para ver a distribuição',
      addBooksToSeeStatus: 'Adicione livros à sua biblioteca para ver o status',
      noGenresTitle: 'Nenhum gênero encontrado',
      addGenresToBooks: 'Adicione gêneros aos seus livros para ver estatísticas',
      noRatingsTitle: 'Nenhuma avaliação ainda',
      rateYourBooks: 'Avalie seus livros lidos para ver estatísticas',
    },
  },
  books: {
    myBooks: 'Meus Livros',
    yourCollection: 'Sua coleção de livros aparecerá aqui',
    booksCount: '{{count}} livros na sua biblioteca',
    wishlistCount: '{{count}} livros na sua lista',
    noBooksYet: 'Nenhum livro ainda',
    addBook: 'Adicionar Livro',
    editBook: 'Editar Livro',
    deleteBook: 'Excluir Livro',
    confirmDelete: {
      title: 'Excluir Livro',
      message: 'Tem certeza que deseja excluir "{{title}}"? Esta ação não pode ser desfeita.',
    },
    noBooks: 'Nenhum livro na sua biblioteca ainda',
    addFirstBook: 'Adicione seu primeiro livro',
    startAddingBooks: 'Comece adicionando alguns livros à sua coleção',
    tryAdjustingFilters: 'Tente ajustar sua busca ou filtros',
    bookAdded: 'Livro adicionado com sucesso',
    bookUpdated: 'Livro atualizado com sucesso',
    bookDeleted: 'Livro excluído com sucesso',
    fields: {
      title: 'Título',
      author: 'Autor',
      isbn: 'ISBN',
      coverUrl: 'URL da Imagem de Capa',
      publishedYear: 'Ano de Publicação',
      pages: 'Páginas',
      genre: 'Gênero',
      status: 'Status',
      type: 'Tipo',
      rating: 'Avaliação',
      notes: 'Notas',
      genres: 'Gêneros',
      selectGenres: 'Selecione os gêneros...',
      selectGenresHelp: 'Selecione os gêneros que melhor descrevem o livro',
      noGenresAvailable: 'Nenhum gênero disponível',
      searchGenres: 'Buscar gêneros...',
      noGenresFound: 'Nenhum gênero encontrado',
      startDate: 'Iniciado',
      endDate: 'Concluído',
      borrowed: 'Livro emprestado (não é meu)',
      borrowedFrom: 'Emprestado de',
      borrowedFromPlaceholder: 'De quem? (opcional)',
      borrowedHelp:
        'Livros emprestados contam como leitura, mas não entram no total da sua biblioteca.',
    },
    isbn: {
      searching: 'Buscando...',
      search: 'Buscar',
      bookFound: 'Livro encontrado! Dados preenchidos automaticamente. Você pode editá-los abaixo.',
      enterIsbnHelp:
        'Digite o ISBN para preencher automaticamente título, autor e outras informações',
      checkingDuplicate: 'Verificando duplicatas...',
      duplicateFound: 'Este ISBN já está cadastrado no livro "{{title}}"',
    },
    scanner: {
      title: 'Escanear Código de Barras',
      instructions: 'Aponte a câmera para o código de barras ISBN na parte de trás do livro',
      scanning: 'Procurando código de barras...',
      startingCamera: 'Iniciando câmera...',
      noCameraSupport: 'Câmera não suportada neste dispositivo',
      permissionDenied:
        'Permissão da câmera negada. Permita o acesso à câmera para escanear códigos.',
      noCameraFound: 'Nenhuma câmera encontrada neste dispositivo',
      unknownError: 'Ocorreu um erro ao acessar a câmera',
      tryAgain: 'Tentar Novamente',
      scanBarcode: 'Escanear Código',
      positionBarcode: 'Posicione o código de barras dentro do retângulo',
      codeFound: 'Código encontrado!',
      processing: 'Processando...',
    },
    status: {
      toRead: 'Para Ler',
      reading: 'Lendo',
      read: 'Lido',
      wishlist: 'Lista de Desejos',
      unread: 'Não Lido',
    },
    type: {
      physical: 'Livro Físico',
      digital: 'Livro Digital',
    },
    actions: {
      title: 'Ações',
      rate: 'Avaliar livro lido',
      writeReview: 'Escrever avaliação',
      yourNotes: 'Suas notas',
      clickToWriteReview: 'Clique para escrever sua avaliação',
      markAsReadToRate: 'Marque como lido para alterar',
      removeRating: 'Remover avaliação',
      noRating: 'Sem avaliação',
      rateExperience: 'Avalie sua experiência de leitura',
      oneStarRating: '⭐ 1 estrela',
      twoStarRating: '⭐⭐ 2 estrelas',
      threeStarRating: '⭐⭐⭐ 3 estrelas',
      fourStarRating: '⭐⭐⭐⭐ 4 estrelas',
      fiveStarRating: '⭐⭐⭐⭐⭐ 5 estrelas',
      addNotesPlaceholder: 'Adicione suas anotações sobre o livro...',
      whenStartedReading: 'Quando você começou a ler este livro',
      whenFinishedReading: 'Quando você terminou de ler este livro',
      startReadingToday: 'Começar a ler hoje',
      markAsReadToday: 'Marcar como lido hoje',
      reread: 'Reler livro',
      moveToWishlist: 'Mover para lista de desejos',
      startReadingNow: 'Começar a ler agora',
      acquiredBook: 'Adquiri o livro',
      moveToLibrary: 'Mover para biblioteca',
      confirmDeleteTitle: 'Excluir livro',
      confirmDeleteMessage:
        'Tem certeza que deseja excluir "{{title}}"? Esta ação não pode ser desfeita.',
      coverUrlHelp:
        'URL da imagem da capa (preenchido automaticamente com ISBN ou você pode inserir manualmente)',
    },
    filters: {
      readInYear: 'Lidos em {{year}}',
      clearReadYear: 'Remover filtro de ano',
    },
  },
  roulette: {
    title: 'Roleta de Livros',
    description: 'Deixe o acaso decidir sua próxima leitura',
    spin: 'Girar',
    createRoulette: 'Criar Roleta',
    selectBooks: 'Selecionar Livros para Roleta',
    selectBooksDescription: 'Escolha pelo menos 1 livro para criar sua roleta de leitura',
    minimumBooks: 'Selecione pelo menos 1 livro',
    booksSelected: 'selecionados',
    startRoulette: 'Começar Roleta',
    noBooksFound: 'Nenhum livro encontrado',
    adjustFiltersToFindBooks: 'Tente ajustar seus filtros para encontrar livros',
    spinning: 'Girando',
    spinningDescription: 'A roleta está escolhendo sua próxima aventura...',
    readyToSpin: 'Pronto para girar!',
    booksInRoulette: '{{count}} livros na roleta',
    winner: 'Sorteado!',
    yourNextRead: 'Sua próxima leitura é...',
    markAsNextRead: 'Marcar como Próxima Leitura',
    startReadingNow: 'Começar a Ler Agora',
    spinAgain: 'Girar Novamente',
    viewHistory: 'Ver Histórico',
    funFact: 'A roleta falou! Hora de começar sua jornada de leitura.',
    history: 'Histórico da Roleta',
    historyDescription: 'Acompanhe seus giros da roleta e descobertas de leitura',
    backToRoulette: 'Voltar à Roleta',
    clearHistory: 'Limpar Histórico',
    noHistory: 'Nenhum histórico de roleta ainda',
    noHistoryDescription: 'Comece a girar para construir seu histórico da roleta!',
    startFirstRoulette: 'Começar Primeira Roleta',
    totalSpins: 'Total de Giros',
    thisWeek: 'Esta Semana',
    avgDuration: 'Duração Média',
    uniqueBooks: 'Livros Únicos',
    allTime: 'Todo o Tempo',
    last24Hours: 'Últimas 24 Horas',
    sortByDate: 'Ordenar por Data',
    sortByBook: 'Ordenar por Livro',
    showingResults: 'Mostrando {{count}} de {{total}} resultados',
    spinDuration: 'Duração do Giro',
    roulettePick: 'Escolha da Roleta',
    noResultsForFilter: 'Nenhum resultado corresponde ao filtro atual',
    // New persistent roulette translations
    myRoulettes: 'Minhas Roletas',
    manageRouletteCollections: 'Gerencie suas coleções de roleta salvas',
    createNew: 'Criar Nova',
    noRoulettesYet: 'Ainda não há roletas',
    createFirstRouletteDescription:
      'Crie sua primeira roleta temática para organizar suas seleções de livros por gênero, humor ou qualquer categoria que você goste.',
    createFirstRoulette: 'Criar Sua Primeira Roleta',
    sortByUpdated: 'Atualizadas Recentemente',
    sortByName: 'Nome',
    sortBySpins: 'Mais Giros',
    roulettesCount: 'roletas',
    books: 'Livros',
    spins: 'Giros',
    currentlyReading: 'Lendo Atualmente',
    lastSpin: 'Último giro',
    needMinimumBooks: 'Adicione pelo menos 1 livro para girar',
    addMoreBooksToSpin: 'Adicione mais livros para habilitar o giro',
    // Create roulette specific translations
    createRouletteDescription: 'Crie uma coleção temática de livros para seleção aleatória',
    rouletteConfiguration: 'Configuração da Roleta',
    rouletteName: 'Nome da Roleta',
    selectBooksMessage: 'Selecionar Livros ({{count}} selecionados)',
    minimumBooksWarning: '⚠️ Selecione pelo menos 1 livro para criar uma roleta',
    nameRequired: 'Nome *',
    namePlaceholder: 'ex., Clássicos de Ficção Científica',
    descriptionOptional: 'Descrição',
    descriptionPlaceholder: 'Descrição opcional para esta roleta...',
    colorTheme: 'Tema de Cor',
    icon: 'Ícone',
    preview: 'Prévia',
    readyToCreate: '✓ Pronto para criar',
    creating: 'Criando...',
    createRouletteButton: 'Criar Roleta',
    // History specific translations
    errorLoadingHistory: 'Erro carregando histórico',
    backToRoulettes: 'Voltar às Roletas',
    last24HoursFilter: 'Últimas 24 Horas',
    noSpinsLast24Hours: 'Nenhum giro nas últimas 24 horas',
    spinLabel: 'giro',
    // Roulette result translations
    newRouletteButton: 'Nova Roleta',
    // Pagination
    previous: 'Anterior',
    next: 'Próximo',
    pageOf: 'Página {{page}} de {{total}}',
    // Error messages
    errorLoadingBooks: 'Erro carregando livros',
    noBooksMessage: 'Nenhum livro encontrado',
    adjustFiltersMessage: 'Tente ajustar seus filtros',
    // Delete roulette
    editRoulette: 'Editar Roleta',
    deleteRoulette: 'Excluir Roleta',
    deleteRouletteTitle: 'Excluir Roleta',
    deleteRouletteMessage:
      'Tem certeza que deseja excluir a roleta "{{name}}"? Esta ação não pode ser desfeita.',
    // Progress and completion
    availableBooks: 'Disponíveis',
    spinsCompleted: 'Concluídos',
    progress: 'Progresso',
    completed: 'Concluída',
    allBooksSpun: 'Todos os livros foram sorteados',
    noMoreBooksToSpin: 'Não há mais livros disponíveis para sortear',
    allBooksAlreadySpun: 'Todos os livros já foram sorteados',
    alreadySelected: 'já selecionado',
    // Progress page translations
    viewProgress: 'Ver Progresso',
    progressDescription: 'Acompanhe o progresso da sua roleta e gire quando quiser',
    spinWheel: 'Girar Roleta',
    spinRoulette: 'Girar Roleta',
    backToList: 'Voltar à Lista',
    suggestBooks: 'Sugerir livros',
    suggestHint: 'Escolhe livros não lidos dos gêneros e autores que você avaliou melhor',
    suggestedBooks_one: '{{count}} livro sugerido e selecionado com base nas suas avaliações.',
    suggestedBooks_other: '{{count}} livros sugeridos e selecionados com base nas suas avaliações.',
    noSuggestions: 'Nenhum livro não lido para sugerir.',
  },
  search: {
    title: 'Buscar Livros',
    description: 'Busque em sua biblioteca',
    placeholder: 'Buscar por título, autor ou ISBN...',
    noResults: 'Nenhum resultado encontrado',
    results: '{{count}} resultado(s) encontrado(s)',
    searchByTitleAuthor: 'Buscar por título ou autor...',
  },
  statistics: {
    title: 'Estatísticas de Leitura',
    description: 'Seus insights e padrões de leitura',
    booksPerMonth: 'Livros por Mês',
    genreDistribution: 'Distribuição por Gênero',
    readingGoal: 'Meta de Leitura',
    averageRating: 'Avaliação Média',
    totalPages: 'Total de Páginas Lidas',
  },
  wishlist: {
    title: 'Minha Lista de Desejos',
    description: 'Livros que você deseja ler no futuro',
    addToWishlist: 'Adicionar à Lista',
    addFirstBook: 'Adicione seu primeiro livro à lista',
    emptyMessage: 'Sua lista de desejos está vazia',
  },
  digitalShelf: {
    title: 'Estante Digital',
    yourCollection: 'Sua coleção de livros digitais aparecerá aqui',
    booksCount: '{{count}} livros digitais em sua biblioteca',
    noBooks: 'Nenhum livro digital ainda',
    addBook: 'Adicionar Livro Digital',
    editBook: 'Editar Livro Digital',
    addFirstBook: 'Adicione seu primeiro livro digital',
    startAddingBooks: 'Comece adicionando alguns livros digitais à sua coleção',
  },
  settings: {
    description: 'Gerencie suas preferências de conta e configurações da aplicação',
    quickActions: 'Ações Rápidas',
    comingSoon: 'Em Breve',
    sectionNotFound: 'Seção de configurações não encontrada',
    sections: {
      preferredGenres: {
        description: 'Gerencie seus gêneros favoritos',
      },
      account: {
        title: 'Conta',
        description: 'Configurações de perfil e conta',
      },
      notifications: {
        title: 'Notificações',
        description: 'Gerencie preferências de notificação',
      },
      appearance: {
        title: 'Aparência',
        description: 'Temas e preferências visuais',
      },
    },
    preferredGenres: {
      title: 'Gêneros Preferidos',
      description: 'Configure seus gêneros favoritos para uma experiência personalizada',
      selectedCount: '{{count}} gêneros selecionados',
      smartSuggestions: 'Sugestões Inteligentes',
      suggestionsHelp: 'Baseado nos livros da sua biblioteca atual',
      searchPlaceholder: 'Buscar gêneros...',
      suggestions: 'Sugestões',
      allGenres: 'Todos os Gêneros',
      both: 'Ambos',
      basedOnLibrary: 'Baseado na Sua Biblioteca',
      otherGenres: 'Outros Gêneros',
      clearAll: 'Limpar Tudo',
      selectedSummary: '{{count}} gêneros selecionados',
      noGenresSelected: 'Nenhum gênero selecionado',
      selectAll: 'Selecionar Todos',
    },
  },
  landing: {
    hero: {
      freeTrial: '🎁 14 dias grátis',
      title: 'Sua Biblioteca',
      subtitle: 'Inteligente',
      description:
        'Nunca mais esqueça um livro que leu. Descubra insights fascinantes sobre seus hábitos de leitura. Deixe o destino escolher sua próxima aventura literária.',
      startFreeTrial: 'Começar Teste Grátis',
      seeHowItWorks: 'Ver Como Funciona',
      dashboardPreview: 'Dashboard Preview',
    },
    features: {
      title: 'Tudo o que Você Precisa para Sua Jornada de Leitura',
      subtitle: 'Funcionalidades poderosas projetadas especialmente para amantes de livros',
      bookRoulette: {
        title: 'Book Roulette',
        badge: 'EXCLUSIVO',
        description:
          'Não consegue decidir o que ler? Deixe nossa exclusiva Roleta de Livros escolher sua próxima aventura aleatoriamente! Crie roletas temáticas e adicione um elemento de surpresa à sua leitura.',
      },
      smartAnalytics: {
        title: 'Analytics Inteligentes',
        description:
          'Gráficos lindos e insights sobre seus padrões de leitura, gêneros favoritos, progresso ao longo do tempo e estatísticas detalhadas da sua biblioteca pessoal.',
      },
      barcodeScanner: {
        title: 'Scanner de Código de Barras',
        description:
          'Adicione livros instantaneamente escaneando códigos de barras ISBN. Detalhes do livro preenchidos automaticamente do nosso banco de dados abrangente.',
      },
      smartOrganization: {
        title: 'Organização Inteligente',
        description:
          'Organize livros por status, gêneros, classificações. Acompanhe datas de leitura, adicione notas pessoais e mantenha sua biblioteca sempre organizada.',
      },
      readingProgress: {
        title: 'Progresso de Leitura',
        description:
          'Acompanhe o que está lendo, quer ler e já completou com monitoramento detalhado de progresso e metas de leitura personalizáveis.',
      },
      multiLanguage: {
        title: 'Multi-idiomas',
        description:
          'Disponível em Português, Inglês e Espanhol. Perfeito para amantes de livros internacionais que leem em diferentes idiomas.',
      },
    },
    howItWorks: {
      title: 'Como o Longbourn Funciona',
      subtitle: 'Comece em três passos simples',
      step1: {
        title: 'Adicione Seus Livros',
        description:
          'Escaneie códigos de barras, pesquise por ISBN ou adicione livros manualmente para construir sua biblioteca digital.',
      },
      step2: {
        title: 'Organize & Analise',
        description:
          'Acompanhe seu progresso de leitura e descubra insights sobre seus hábitos com analytics lindos e detalhados.',
      },
      step3: {
        title: 'Descubra o Próximo',
        description:
          'Use a Roleta de Livros para deixar o acaso decidir sua próxima leitura ou navegue sua biblioteca organizada.',
      },
    },
    pricing: {
      badge: '🎁 14 dias grátis para testar',
      title: 'Escolha Seu Plano',
      subtitle: 'Comece com 14 dias gratuitos. Cancele a qualquer momento.',
      monthly: {
        title: 'Plano Mensal',
        price: 'R$ 9,99',
        period: '/mês',
        description: 'Flexibilidade total com pagamento mensal',
        cta: 'Começar Teste Grátis',
      },
      annual: {
        title: 'Plano Anual',
        price: 'R$ 34,99',
        period: '/ano',
        originalPrice: 'R$ 119,88',
        savings: 'Economize R$ 84,89',
        description: 'Melhor valor! Apenas {{perMonth}} por mês',
        discount: '71% OFF',
        cta: 'Começar Teste Grátis',
        prioritySupport: '💎 Acesso prioritário ao suporte',
      },
      features: {
        freeTrial: '✨ 14 dias de teste gratuito',
        unlimitedLibrary: 'Biblioteca ilimitada de livros',
        bookRoulette: 'Book Roulette exclusivo',
        barcodeScanner: 'Scanner de código de barras',
        detailedAnalytics: 'Analytics detalhados',
        multiLanguage: 'Suporte a 3 idiomas',
      },
    },
    spotlight: {
      badge: '🎲 FUNCIONALIDADE EXCLUSIVA',
      title: 'Deixe o Destino Escolher Sua Próxima',
      titleHighlight: ' Aventura',
      description:
        'Nossa Roleta de Livros é a única funcionalidade do tipo. Crie roletas temáticas, gire a roda e descubra sua próxima grande leitura. Perfeito para leitores indecisos!',
      features: {
        customRoulettes: 'Crie roletas temáticas personalizadas por gênero, humor ou categoria',
        trackHistory: 'Acompanhe seu histórico de roletas e estatísticas de giros',
        neverWorryAgain: 'Nunca mais se preocupe em escolher seu próximo livro',
      },
      interactiveRoulette: 'Roleta Interativa',
      demoText: 'Demo disponível após o cadastro',
    },
    cta: {
      title: 'Pronto para Transformar Sua Experiência de Leitura?',
      description:
        'Junte-se a milhares de amantes de livros que já organizaram sua jornada de leitura com o Longbourn.',
      button: 'Começar Teste Grátis',
      benefits: '🎁 14 dias grátis • 🚫 Sem cartão de crédito • ⚡ Cancele a qualquer momento',
    },
    footer: {
      madeWith: 'Feito com ❤️ para amantes de livros em todo o mundo',
      privacy: 'Privacidade',
      terms: 'Termos',
    },
  },
  insights: {
    title: 'Insights',
    seeAll: 'Ver todos',
    noBooksYet: 'Adicione livros para ver este insight',
    days_one: '{{count}} dia',
    days_other: '{{count}} dias',
    bookCount_one: '{{count}} livro',
    bookCount_other: '{{count}} livros',
    missingDates: {
      title_one: '{{count}} livro lido sem data de término',
      title_other: '{{count}} livros lidos sem data de término',
      description: 'Sem a data eles não aparecem em "Lidos Este Ano" nem no Progresso Anual.',
      fix: 'Completar datas',
      modalTitle: 'Quando você terminou?',
      modalHint: 'Sugerimos a data da última alteração de cada livro. Ajuste se precisar.',
    },
    continueReading: {
      title: 'Continue lendo',
      empty: 'Nenhum livro em andamento. Que tal começar um?',
      noStartDate: 'Sem data de início',
      startedToday: 'Começou hoje',
      daysReading_one: 'Lendo há {{count}} dia',
      daysReading_other: 'Lendo há {{count}} dias',
    },
    goal: {
      title: 'Meta de {{year}}',
      empty: 'Defina quantos livros quer ler em {{year}}.',
      set: 'Definir meta',
      edit: 'Editar meta',
      remove: 'Remover meta',
      howMany: 'Quantos livros em {{year}}?',
      reached: 'Meta batida! 🎉',
      onTrack: 'Você está no ritmo certo.',
      ahead_one: '{{count}} livro à frente do ritmo',
      ahead_other: '{{count}} livros à frente do ritmo',
      behind_one: '{{count}} livro atrás do ritmo',
      behind_other: '{{count}} livros atrás do ritmo',
    },
    streak: {
      title: 'Sequência de leitura',
      months_one: '{{count}} mês',
      months_other: '{{count}} meses',
      start: 'Termine um livro este mês para começar sua sequência.',
      active: 'Você já terminou um livro este mês. 🔥',
      keepAlive: 'Termine um livro este mês para manter a sequência.',
      longest_one: 'Recorde: {{count}} mês',
      longest_other: 'Recorde: {{count}} meses',
    },
    readingTime: {
      title: 'Tempo de leitura',
      basedOn_one: 'Baseado em {{count}} livro com datas',
      basedOn_other: 'Baseado em {{count}} livros com datas',
      empty: 'Preencha as datas de início e término dos livros lidos para ver seu ritmo.',
      perBook: 'por livro',
      fastest: 'Mais rápido',
      slowest: 'Mais lento',
    },
    topAuthors: {
      title: 'Top autores',
      description: 'Autores com mais livros na sua biblioteca',
      readOfTotal: '{{read}}/{{total}} lidos',
    },
    backlog: {
      title: 'Pilha por gênero',
      description: 'Onde estão os livros que você tem e ainda não leu',
      empty: 'Adicione gêneros aos seus livros para ver este insight.',
      unreadOfOwned: '{{unread}} de {{owned}} não lidos',
    },
    pace: {
      title: 'Compra vs. leitura',
      added: 'Adicionados',
      finished: 'Terminados',
      noActivity: 'Nenhuma atividade nos últimos 12 meses',
      buyingMore:
        'Últimos 12 meses: {{added}} adicionados, {{finished}} terminados. A pilha está crescendo.',
      readingMore:
        'Últimos 12 meses: {{added}} adicionados, {{finished}} terminados. Você está em dia!',
    },
    stalled: {
      title: 'Livros parados',
      description: 'Em "Lendo" há mais de {{count}} dias',
      pause: 'Pausar',
      pauseHint: 'Volta o livro para "Para ler"',
    },
    preferred: {
      title: 'Gostos vs. leituras',
      description: 'Gêneros que você diz preferir comparados com o que você lê',
      noPreferences: 'Você ainda não escolheu gêneros preferidos.',
      setPreferences: 'Escolher agora',
      preferredTag: 'Gênero preferido',
      readCount_one: '{{count}} lido',
      readCount_other: '{{count}} lidos',
      surprise: 'Você lê bastante {{genre}}, mas não está nos seus preferidos.',
      neglected: '{{genre}} está nos seus preferidos, mas você ainda não leu nenhum.',
    },
    yearInReview: {
      cta: 'Retrospectiva',
      title: 'Retrospectiva {{year}}',
      subtitle: 'Seu ano de leitura em números',
      selectYear: 'Escolher ano',
      share: 'Compartilhar imagem',
      generating: 'Gerando...',
      downloaded: 'Imagem baixada!',
      imageTitle: 'Minha retrospectiva de leitura',
      imageBooksRead_one: 'livro lido',
      imageBooksRead_other: 'livros lidos',
      empty: 'Nenhum livro terminado em {{year}} ainda.',
      booksRead: 'Livros lidos',
      booksAdded: 'Livros adicionados',
      averageRating: 'Nota média',
      physicalDigital: 'Físico / Digital',
      topGenre: 'Gênero do ano',
      topAuthor: 'Autor do ano',
      bestRated: 'Melhor avaliado',
      fastest: 'Leitura mais rápida',
      busiestMonth: 'Mês mais produtivo',
      averageTime: 'Tempo médio',
      allBooks: 'Todos os livros do ano',
      shareTitle: '📚 Minha retrospectiva de leitura {{year}}',
    },
    notes: {
      title: 'Anotações',
      subtitle_one: '{{count}} livro com anotações',
      subtitle_other: '{{count}} livros com anotações',
      searchPlaceholder: 'Buscar nas anotações, títulos e autores...',
      empty:
        'Você ainda não escreveu anotações. Adicione notas aos seus livros e elas aparecem aqui.',
    },
  },
  clubs: {
    title: 'Clubes do livro',
    subtitle: 'Leia junto com as amigas: desafios, empréstimos e livros viajantes',
    create: 'Criar clube',
    edit: 'Editar clube',
    memberCount_one: '{{count}} membro',
    memberCount_other: '{{count}} membros',
    notFound: 'Clube não encontrado ou você não faz parte dele.',
    backToClubs: 'Voltar para os clubes',
    leave: 'Sair do clube',
    leaveTitle: 'Sair do clube?',
    leaveMessage: 'Você vai sair de "{{club}}". Para voltar, precisará de um novo convite.',
    deleteTitle: 'Excluir clube?',
    deleteMessage: '"{{club}}" e todos os desafios dele serão excluídos para todos os membros.',
    empty: {
      title: 'Você ainda não está em nenhum clube',
      description: 'Crie um clube e convide as amigas, ou abra o link de convite que recebeu.',
    },
    form: {
      name: 'Nome do clube',
      namePlaceholder: 'Ex.: Clube das Meninas',
      description: 'Descrição',
      descriptionPlaceholder: 'Encontros mensais, regras, o que quiser…',
      create: 'Criar',
    },
    roles: {
      admin: 'Admin',
      member: 'Membro',
    },
    members: {
      title_one: '{{count}} membro',
      title_other: '{{count}} membros',
      you: 'você',
      makeAdmin: 'Tornar admin',
      makeMember: 'Remover admin',
      remove: 'Remover',
      removeTitle: 'Remover membro?',
      removeMessage: '{{name}} sairá do clube.',
    },
    invite: {
      title: 'Convidar',
      description: 'Gere um link e mande para quem você quer no clube.',
      create: 'Gerar link de convite',
      share: 'Compartilhar link',
      copied: 'Link copiado!',
      revoke: 'Desativar link',
      expires: 'Válido até {{date}}',
      shareText: 'Entre no clube "{{club}}" no Longbourn',
    },
    join: {
      invitedBy: '{{name}} convidou você para',
      accept: 'Entrar no clube',
      open: 'Abrir clube',
      invalid: 'Convite inválido ou expirado',
      invalidHint: 'Peça um novo link para alguém do clube.',
    },
  },
  challenges: {
    title: 'Desafios',
    create: 'Novo desafio',
    edit: 'Editar desafio',
    empty: 'Nenhum desafio ainda. Crie um e cada uma sugere as categorias!',
    notFound: 'Desafio não encontrado.',
    formerMember: 'Ex-membro',
    categoryCount_one: '{{count}} categoria',
    categoryCount_other: '{{count}} categorias',
    categoryProgress: '{{count}} de {{total}} categorias definidas',
    myProgress: 'Você: {{done}}/{{total}}',
    deleteTitle: 'Excluir desafio?',
    deleteMessage:
      '"{{name}}", as categorias, indicações e comentários serão excluídos para todas.',
    phase: {
      upcoming: 'Em breve',
      active: 'Em andamento',
      finished: 'Encerrado',
    },
    legend: {
      done: 'Lido no período',
      picked: 'Indicado',
    },
    filter: {
      all: 'Todas as categorias',
      todo: 'Sem livro meu',
      picked: 'Indiquei, falta ler',
      done: 'Concluídas por mim',
    },
    form: {
      defaultName: 'Desafio {{year}}',
      name: 'Nome',
      startsOn: 'Início',
      endsOn: 'Fim',
      datesInvalid: 'O fim precisa ser depois do início.',
      periodHint: 'Só contam livros terminados dentro desse período.',
      target: 'Total de categorias',
      targetHint: 'Ex.: 33 para 3 pessoas sugerindo 11 cada.',
      description: 'Regras',
      descriptionPlaceholder: 'Combinados do grupo, prêmios, prazos…',
    },
    categories: {
      title: 'Categorias',
      empty: 'Nenhuma categoria ainda. Sugira a primeira acima!',
      suggest: 'Sugerir categoria',
      titlePlaceholder: 'Ex.: Livro de capa branca',
      descriptionPlaceholder: 'Detalhe (opcional)',
      quota: 'Você sugeriu {{done}} de {{quota}}',
      similar: 'Já existe uma parecida: "{{title}}"',
      suggestedBy: 'Sugerida por {{name}}',
      by: 'por {{name}}',
      everyonesPicks: 'Indicações ({{count}})',
      noPicks: 'Ninguém indicou um livro ainda.',
      deleteTitle: 'Excluir categoria?',
      deleteMessage_one: 'A categoria e {{count}} indicação serão excluídas.',
      deleteMessage_other: 'A categoria e {{count}} indicações serão excluídas.',
    },
    entry: {
      mine: 'Meu livro para esta categoria',
      pickBook: 'Escolha um livro da sua biblioteca',
      noBooks: 'Nenhum livro disponível',
      pick: 'Indicar',
      addNewBook: 'Cadastrar livro novo',
      newBook: 'Novo livro (já entra como sua indicação)',
      change: 'Trocar livro',
      remove: 'Remover',
      markReadToday: 'Marcar como lido hoje',
      outsidePeriodHint: 'Hoje está fora do período do desafio',
      readOn: 'lido em {{date}}',
      readOutsidePeriod: 'Lido em {{date}}, fora do período, não conta',
      reading: 'Lendo',
      notRead: 'Ainda não lido',
      picked: 'indicado',
      done: 'lido',
      none: 'sem livro',
      bookDeleted: 'Esse livro foi removido da sua biblioteca.',
    },
    comments: {
      count_one: '{{count}} comentário',
      count_other: '{{count}} comentários',
      hide: 'Esconder comentários',
      empty: 'Nenhum comentário ainda.',
      placeholder: 'Escreva um comentário…',
      send: 'Enviar',
      add: 'Comentar',
    },
  },
  loans: {
    lend: 'Emprestar',
    lendTitle: 'Emprestar "{{title}}"',
    borrower: 'Para quem',
    chooseFriend: 'Escolha alguém dos seus clubes',
    someoneElse: 'Outra pessoa (fora do app)',
    friendHint:
      'O livro aparece na biblioteca dela como emprestado, e as leituras contam nas estatísticas dela.',
    borrowerName: 'Nome',
    borrowerNamePlaceholder: 'Ex.: Tia Lúcia',
    lentOn: 'Emprestado em',
    lentTo: 'Com {{name}} desde {{date}}',
    borrowedFrom: 'Emprestado de {{name}}',
    borrowed: 'Emprestado',
    returned: 'devolvido',
    markReturned: 'Marcar como devolvido',
    cardTitle: 'Empréstimos',
    withMe_one: 'Com você ({{count}})',
    withMe_other: 'Com você ({{count}})',
    lentOut_one: 'Você emprestou ({{count}})',
    lentOut_other: 'Você emprestou ({{count}})',
    from: 'de {{name}}',
    to: 'com {{name}}',
    since: 'desde {{date}}',
  },
  traveling: {
    title: 'Livros viajantes',
    create: 'Novo livro viajante',
    empty: 'Nenhum livro viajando. Mande um livro seu passar de mão em mão!',
    book: 'Livro',
    chooseBook: 'Escolha um livro seu',
    noBooks: 'Nenhum livro seu disponível',
    route: 'Rota',
    routeHint: 'Toque nas pessoas na ordem em que o livro vai passar. No fim, ele volta para você.',
    noReaders: 'Convide alguém para o clube primeiro.',
    note: 'Recado para as leitoras',
    notePlaceholder: 'Ex.: cuidado com a capa, pode marcar a lápis…',
    start: 'Mandar viajar',
    ownedBy: 'Livro de {{name}}',
    traveling: 'Viajando',
    home: 'Voltou para casa',
    backHome: '🏠 Voltou para casa em {{date}}',
    withReaderToday: 'Com {{name}} desde hoje',
    withReader_one: 'Com {{name}} há {{count}} dia',
    withReader_other: 'Com {{name}} há {{count}} dias',
    next: 'próxima: {{name}}',
    nextHome: 'depois volta para a dona',
    pass: 'Passar adiante',
    passTo: 'Entregar para {{name}}',
    sendHome: 'Devolver para a dona',
    passNotePlaceholder: 'Deixe um recado para as próximas (opcional)',
    finished_one: '{{count}} viagem concluída',
    finished_other: '{{count}} viagens concluídas',
  },
}
